'use strict';

angular.module('myConsultApp')
    .factory('PatientsService', function ($resource, ENV, Session) {

        var patientsService = {};

        patientsService.getPatients = function (search,species,organization,status,order) {
            var patients = $resource(ENV.apiEndpoint + '/1.0/patients/',{},{get:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});

			var searchData = {
				search: search,
				organization: organization,
        status:status,
				order: order
			};

			if(species !== null){
				searchData.species = species;
			}

            return patients.get(searchData).$promise.then(function(response) {
                return response;
            });
        };

        patientsService.getPatientPage = function (url) {
            var patients = $resource(url,{},{get:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});

            return patients.get({}).$promise.then(function(response) {
                return response;
            });
        };



        return patientsService;
  });
